import { Injectable, inject } from "@angular/core";
import {
  Route,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSegment,
} from "@angular/router";
import { AuthAmplifyService } from "../shared/service/auth-amplify.service";
import { TranslationService } from "../shared/service/translation.service";

const CONTENT_MODERATION_PROFILES = ["MBRDI-Developer", "MBRDI-Testers"];

@Injectable({ providedIn: "root" })
export class AuthGuard {
  userData: unknown;
  jwtData: unknown;
  aliasListSelected: unknown;
  private readonly router = inject(Router);
  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly _translationService = inject(TranslationService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Promise<boolean> {
    if (localStorage.getItem("profile")) {
      this.aliasListSelected = true;
    }
    const userData = localStorage.getItem("loggedIn");

    if (userData) {
      let isAccessible = false;
      const enableProfileFeature =
        this._translationService.featureFlags?.profile.enableProfileFeature;
      if (enableProfileFeature) {
        if (state.url.includes("/events") && this.aliasListSelected) {
          isAccessible = true;
        } else if (state.url.includes("/locations") && this.aliasListSelected) {
          isAccessible = true;
        } else if (
          state.url.includes("/gmap")&&
          this.aliasListSelected
        ){isAccessible = true;}
        else if (state.url.includes("/profile")) {
          isAccessible = this.handleFlagBasedProfileRedirects(state);
        } else {
          this.router.navigate(["profile"]);
        }
      } else {
        if (state.url.includes("/events")) {
          isAccessible = true;
        } else {
          this.router.navigate(["events"]);
        }
      }
      return isAccessible;
    } else {
      this.router.navigate(["auth"]);
      return false;
    }
  }

  private handleFlagBasedProfileRedirects(state: RouterStateSnapshot): boolean {
    let isAccessible = false;
    const profileFeatureFlags = this._translationService.featureFlags?.profile;
    switch (true) {
      case state.url.includes("member-list") &&
        profileFeatureFlags.enableManageBusiness:
      case state.url.includes("fleet") && profileFeatureFlags.enableManageFleet:
        isAccessible = true;
        break;
      case state.url.includes("content-moderation") &&
        profileFeatureFlags.enableContentModeration &&
        CONTENT_MODERATION_PROFILES.includes(localStorage.getItem("profileName") ?? ""):
        isAccessible = true;
        break;
      case state.url.includes("member-list") &&
        !profileFeatureFlags.enableManageBusiness:
      case state.url.includes("fleet") &&
        !profileFeatureFlags.enableManageFleet:
      case state.url.includes("content-moderation") &&
        (!profileFeatureFlags.enableContentModeration ||
          !CONTENT_MODERATION_PROFILES.includes(localStorage.getItem("profileName") ?? "")):
        this.router.navigate(["not-found"]);
        break;
      default:
        isAccessible = true;
        break;
    }
    return isAccessible;
  }

  getRoleGroup(jwt: string) {
    try {
      return JSON.parse(atob(jwt.split(".")[1]));
    } catch (_err) {
      return null;
    }
  }

  canMatch(_route: Route, _segments: UrlSegment[]): boolean {
    const enableProfileFeature =
      this._translationService.featureFlags?.profile.enableProfileFeature;
    if (enableProfileFeature) {
      return true;
    } else {
      this.router.navigate(["/page-not-found"]);
      return false;
    }
  }
}
